import script from "./AnalyticsFatigueSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalyticsFatigueSection.vue?vue&type=script&setup=true&lang=js"

import "./AnalyticsFatigueSection.vue?vue&type=style&index=0&id=08cdc516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08cdc516"]])

export default __exports__